<template>
    <table class="table table-sm table-borderless meal-table">
        <tbody>
        <tr v-for="textblock in content.TextBlocks">
            <td :class="tdClass">
                <img :src="require(`@/assets/img/Food icons/${textblock.Icon}`)" alt="food" width="60">
            </td>
            <td :class="tdClass">
                <div>
                    <p class="adviestitle">{{ textblock.Title }}</p>
                    <span v-html="textblock.ContentText"></span>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
export default {
  props: {
    content: Object
  },
  name: 'FormattedCmsText',
  computed: {
    tdClass () {
      return 'p-l-10 p-t-10 p-b-5'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utilities/FormattedCmsText.vue